module.exports = __webpack_public_path__ + "static/media/suu.005ce40e.svg";